import React from "react";

import PageHeader from "../../../molecules/PatientDetailsV2/PageHeader/PageHeader";
import ScoreProgress from "../../../molecules/Progress/ScoreProgress/ScoreProgress";
import ProgressTabs from "../../../molecules/Progress/ProgressTabs/ProgressTabs";

const tabs = ["Exercise", "Diet", "Success"];

const MainGoalsPage = () => {
  return (
    <div>
      <PageHeader title="Custom Goals" />
      {/* <ScoreProgress /> */}
      {/* <AssessmentGoal tabs={tabs} /> */}
      <ProgressTabs tabs={tabs} isPrimary={false} />
    </div>
  );
};

export default MainGoalsPage;
